"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRSignatureSSSPlugin = exports.SecurityHeader = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const authoriser_helper_1 = require("../../../../security/authoriser/helpers/authoriser.helper");
const security_1 = require("../../../../security");
var SecurityHeader;
(function (SecurityHeader) {
    SecurityHeader["AUTHORIZATION_REQUIRED"] = "Authorization-Required";
    SecurityHeader["SIGNATURE_KEY_EXPIRED"] = "Signature-Key-Expired";
    SecurityHeader["LIMIT_EXCEEDED"] = "limit-exceeded";
})(SecurityHeader || (exports.SecurityHeader = SecurityHeader = {}));
class XHRSignatureSSSPlugin {
    constructor(signature) {
        this.name = this.constructor.name;
        this.requestId = null;
        this.signature = signature;
    }
    async handleResponse(response) {
        const isLastFlowRequest = this.signature.isSignatureLastProcess(this.requestId);
        const { data: { httpStatus, responseHeaders: { ['x-security']: securityHeader }, }, } = response;
        // eslint-disable-next-line complexity
        return new Promise(resolve => {
            switch (httpStatus) {
                case web_ui_framework_1.HTTP_STATUS.FORBIDDEN:
                case web_ui_framework_1.HTTP_STATUS.FORBIDDEN_AUTHORISER:
                    if (securityHeader === SecurityHeader.AUTHORIZATION_REQUIRED) {
                        this.signature.initialize({ response, resolve });
                    }
                    else if (isLastFlowRequest) {
                        this.signature.setError(security_1.SignatureStateEnum.SIGNATURE_FAILED);
                    }
                    else {
                        resolve(response);
                    }
                    break;
                case web_ui_framework_1.HTTP_STATUS.PRECONDITION_FAILED:
                    if (securityHeader === SecurityHeader.SIGNATURE_KEY_EXPIRED || securityHeader === SecurityHeader.LIMIT_EXCEEDED) {
                        if (!this.signature.isSignatureProcessStarted()) {
                            this.signature.initialize({ response, resolve });
                        }
                        const errorType = securityHeader === SecurityHeader.SIGNATURE_KEY_EXPIRED
                            ? security_1.SignatureError.EXPIRED_SIGNATURE_KEY
                            : security_1.SignatureError.CONSECUTIVE_ERRORS;
                        this.signature.setError(security_1.SignatureStateEnum.SIGNATURE_FAILED, errorType);
                        return;
                    }
                    resolve(response);
                    break;
                default:
                    if (isLastFlowRequest) {
                        this.signature.finishSuccessfully(response);
                    }
                    resolve(response);
            }
        });
    }
    async handleRequest(request) {
        this.requestId = (0, authoriser_helper_1.hashRequestURL)(request.url);
        if (this.signature.isSignatureLastProcess(this.requestId)) {
            request.headers = {
                ...request.headers,
                progressId: this.signature.getSignatureId(),
            };
        }
        return request;
    }
}
exports.XHRSignatureSSSPlugin = XHRSignatureSSSPlugin;
//# sourceMappingURL=xhrSignatureSSSPlugin.js.map